import {Platform, ViewStyle, View, StyleProp, TextStyle} from 'react-native';
import React, {useCallback, useMemo} from 'react';
import {TouchableOpacity} from 'react-native';
import {useStyles} from '../../../../hooks/styles';
import {StyleSheet} from 'react-native';
import {images} from '../../../../../assets/icons';
import {Text} from '../../../text';
export interface CheckboxProps {
  testIDprefix: string;
  onChange?(val: boolean): any;
  value: boolean;
  label?: string;
  labelStyle?: StyleProp<TextStyle>;
  disabled?: boolean;
  wrapExtraStyles?: ViewStyle;
  style?: StyleProp<ViewStyle>;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  labelStyle,
  testIDprefix,
  onChange,
  label,
  value,
  wrapExtraStyles,
  disabled,
  style,
}) => {
  const CheckMarkIcon = useMemo(() => {
    return value === true ? images.checkOn : value === false ? images.checkOff : images.checkInter;
  }, [value]);

  const styles = useStyles(({theme}) => ({
    activeColor: {
      color: theme.color.primaryColor,
    },
    nonActiveColor: {
      color: theme.color.textColor,
    },
    disabledColor: {
      color: theme.color.nonActiveCheckBoxColor,
    },
    wrap: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    check: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: 24,
      height: 24,
      color: disabled
        ? theme.color.nonActiveCheckBoxColor
        : value === false
        ? theme.color.textColor
        : theme.color.primaryColor,
    },
    label: {
      ...theme.fonts.label,
      paddingLeft: 11,
    },
  }));

  const handlePress = useCallback(() => {
    if (onChange) {
      onChange(!value);
    }
  }, [onChange, value]);

  return (
    <TouchableOpacity
      testID={`${testIDprefix}-container-id`}
      disabled={disabled}
      activeOpacity={Platform.OS === 'web' ? 1 : 0.5}
      style={[StyleSheet.flatten([styles.wrap, wrapExtraStyles]), style]}
      onPress={handlePress}>
      <View style={styles.check}>
        <CheckMarkIcon width={22} height={22} color={styles.check.color} />
      </View>
      {label ? (
        <Text testID={`${testIDprefix}-label-id`} style={[styles.label, labelStyle]}>
          {label}
        </Text>
      ) : null}
    </TouchableOpacity>
  );
};
